import Tooltip from '@material-ui/core/Tooltip';
import VerifiedIcon from '@mui/icons-material/Verified';
import { MY_ACCOUNT } from 'constants/Paths';
import { useProductConsultation } from 'hooks/useProductConsultation';
import { useState } from 'react';
import ConsultBtn from './ConsultBtn';
import ConsultPopup from './ConsultPopup';
import styles from './styles.module.css';

const ELIGIBILITY_REASON_CUSTOMER_NOT_VERIFIED = 'CUSTOMER_NOT_VERIFIED';
const INVOICE_INFO_URL = `${MY_ACCOUNT}?tab=5`;

export const VARIANT_LIST = {
  DETAIL: 'DETAIL',
  LIST: 'LIST',
  CART: 'CART',
  LIST_HORIZONTAL: 'LIST_HORIZONTAL',
  ICON: 'ICON',
};

export default function ConsultSpecialProductBtn({ className, product, variant = VARIANT_LIST.DETAIL }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { shouldDisableConsultButton } = useProductConsultation();

  // Special-ingredient drug + southern (miền nam) customer: keep the consult
  // button visible but disabled, so the customer can neither consult nor add
  // the product to cart.
  const isDisabled = shouldDisableConsultButton(product);

  const handleConsultClick = () => {
    if (isDisabled) return;
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  // BV-2262: seller chỉ bán cho khách đã xác thực → không cho mua, không mở tư vấn.
  if (product?.eligibility?.reason === ELIGIBILITY_REASON_CUSTOMER_NOT_VERIFIED) {
    const tooltipContent = (
      <span>
        Vui lòng kiểm tra/cập nhật thông tin xuất hóa đơn, tại{' '}
        <a href={INVOICE_INFO_URL} className={styles.notVerifiedLink} onClick={(e) => e.stopPropagation()}>
          Thông tin tài khoản
        </a>
      </span>
    );
    return (
      <Tooltip title={tooltipContent} arrow interactive placement="top">
        <p className={`${styles.notVerifiedMessage} ${className || ''}`}>
          <VerifiedIcon className={styles.notVerifiedIcon} />
          <span>Cần xác thực tài khoản</span>
        </p>
      </Tooltip>
    );
  }

  return (
    <>
      <ConsultBtn className={className} onClick={handleConsultClick} variant={variant} disabled={isDisabled} />
      <ConsultPopup open={isPopupOpen} onClose={handleClosePopup} product={product} />
    </>
  );
}
